export default [{
	path: '/cycling/comment',
	name: 'cyclingComment',
	component: () => import('@/projects/cycling/routeComment'),
	meta: {
		title: '全部评论',
		index: 0,
		param: "relevanceId=关联ID&typeId=评论类型  /评论类型(1路线评论，2赛段评论，3赛事评论，4视频评论，5商品评论)"
	}
},
{
	path: '/cycling/stageRanking',
	name: 'stageRanking',
	component: () => import('@/projects/cycling/stageRanking'),
	meta: {
		title: '排行榜',
		index: 0,
		param: "Id=关联ID，typeId=类型ID 类型ID（1：路线，2赛段，3赛事）"
	}
},
{
	path: '/cycling/matchEnroll',
	name: 'matchEnroll',
	component: () => import('@/projects/cycling/matchEnroll'),
	meta: {
		title: '赛事报名',
		index: 0,
	}
},
{
	path: '/cycling/raceDetail',
	name: 'raceDetail',
	component: () => import('@/projects/cycling/raceDetail'),
	meta: {
		title: '赛事详情',
		index: 0,
	}
},
{
	path: '/cycling/moreCondition',
	name: 'moreCondition',
	component: () => import('@/projects/cycling/moreCondition'),
	meta: {
		title: '更多条件',
		index: 0,
	}
},
{
	path: '/cycling/raceNewsDetail',
	name: 'raceNewsDetail',
	component: () => import('@/projects/cycling/raceNewsDetail'),
	meta: {
		title: '赛事新闻详情',
		index: 0,
		param: "Id=赛事新闻ID"
	}

},
{
	path: '/cycling/teamUp',
	name: 'teamUp',
	component: () => import('@/projects/cycling/teamUp'),
	meta: {
		title: '活动计划',
		index: 0,
	}

},
{
	path: '/cycling/evaluation',
	name: 'evaluation',
	component: () => import('@/projects/cycling/evaluation'),
	meta: {
		title: '自行车测评',
		index: 0,
	}

}
]


// WEBPACK FOOTER //
// ./src/projects/cycling/index.js